/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTimExecutionRequest
 */
export interface UpdateTimExecutionRequest {
    /**
     * 
     */
    overridden_report?: string | null;
    /**
     * 
     */
    overridden_level?: string | null;
}

/**
 * Check if a given object implements the UpdateTimExecutionRequest interface.
 */
export function instanceOfUpdateTimExecutionRequest(value: object): value is UpdateTimExecutionRequest {
    return true;
}

export function UpdateTimExecutionRequestFromJSON(json: any): UpdateTimExecutionRequest {
    return UpdateTimExecutionRequestFromJSONTyped(json, false);
}

export function UpdateTimExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimExecutionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'overridden_report': json['overridden_report'] === undefined ? undefined : json['overridden_report'] === null ? null : json['overridden_report'],
        'overridden_level': json['overridden_level'] === undefined ? undefined : json['overridden_level'] === null ? null : json['overridden_level'],
    };
}

export function UpdateTimExecutionRequestToJSON(json: any): UpdateTimExecutionRequest {
    return UpdateTimExecutionRequestToJSONTyped(json, false);
}

export function UpdateTimExecutionRequestToJSONTyped(value?: UpdateTimExecutionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overridden_report': value['overridden_report'],
        'overridden_level': value['overridden_level'],
    };
}

